import { AppState } from "../../../redux-configuration/AppState";

export const validateOrderLoadingSelector = (appState: AppState): boolean => appState.clickCollect.validateOrder.loading
export const validateOrderErrorSelector = (appState: AppState): string | undefined => appState.clickCollect.validateOrder.error
export const validateOrderSuccessSelector = (appState: AppState): string | undefined => appState.clickCollect.validateOrder.data
